/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import Button from "./ui/Button";
import Icon from "./ui/Icon";
import Text from "./ui/Text";
import React from "react";
import Flex from "./ui/Flex";
import { useTranslate } from "../hooks/useTranslate";

const QuantityInput = ({
  value,
  min = 1,
  max,
  disabled = false,
  onUpdate,
  onAdd,
}) => {
  const { _t } = useTranslate();
  const decrementDisabled = disabled || +value <= min;
  const incrementDisabled = disabled || (max != null && +value >= max);

  return (
    <Flex $justify="flex-end">
      {value ? (
        <Flex $align="center" $gap="0.5rem">
          <Button
            icon={<Icon.Minus />}
            aria-label={_t("Decrease quantity")}
            onClick={() => onUpdate(+value - 1)}
            variant="outline"
            size="icon"
            disabled={decrementDisabled}
          />
          <Text
            color="dark"
            weight="bold"
            size="large"
            style={{ width: "35px", textAlign: "center" }}
            children={value}
          />
          <Button
            icon={<Icon.Plus />}
            aria-label={_t("Increase quantity")}
            onClick={() => onUpdate(+value + 1)}
            variant="outline"
            size="icon"
            disabled={incrementDisabled}
          />
        </Flex>
      ) : (
        <Button
          icon={<Icon.Plus />}
          onClick={() => onAdd && onAdd()}
          title="add_product"
          variant="outline"
          size="m"
          disabled={disabled}
        />
      )}
    </Flex>
  );
};

export default QuantityInput;
